import { render, staticRenderFns } from "./personalMove.vue?vue&type=template&id=1404381e&scoped=true&"
import script from "./personalMove.vue?vue&type=script&lang=js&"
export * from "./personalMove.vue?vue&type=script&lang=js&"
import style0 from "./personalMove.vue?vue&type=style&index=0&id=1404381e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1404381e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
